var map = {
	"./booking-01.jpg": 97599,
	"./booking-02.jpg": 83248,
	"./booking-03.jpg": 51821,
	"./booking-04.jpg": 16390,
	"./booking-05.jpg": 75875,
	"./booking-06.jpg": 29812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83126;